import { Component, ViewEncapsulation } from '@angular/core';
import { RouterServiceService } from '../../services/router-service.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { PosHttpService } from '../../services/pos.http.service';


@Component({
  selector: 'hw-header-profile',
  templateUrl: './hw-header-profile-component.component.html',
  styleUrl: './hw-header-profile-component.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class HwHeaderProfileComponentComponent {

  constructor(private router: Router, private routerServices: RouterServiceService, private posHttpSvcs: PosHttpService) { }

  user = {
    team: '',
    name: '',
    emailId: '',
    releaseVersion: ''
  };

  ngOnInit(): void {
    this.loadUser();
  }
  loadUser() {
    this.posHttpSvcs.authGet('v1/ui/loadUser', 'loadUser').subscribe((resp: any) => {
      this.user = resp.data;
    });
  }

  serverDetails() {
    this.router.navigate(['/app/main/serverHealth']);
  }

  logout() {
    this.routerServices.removeData('menuItemArray');
    this.logoutToken().subscribe({
      next: (resp) => {
        this.router.navigateByUrl('/login');
      }
    })
  }

  logoutToken(): Observable<any> {
    return this.posHttpSvcs.authPost('v1/auth/logout', 'logout', {});
  }

}
